module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"menu.cabinet.change":"Changer de cabinet","menu.cabinet.choose":"Choisir un cabinet","menu.disconnect":"Se déconnecter","menu.my.account":"Mon compte","menu.erase.user.preferences":"Effacer préférences","user.preferences.reset.success":"Le préférences utilisateurs ont été effacées."}}')
  delete Component.options._Ctor
}
